export enum ZoneType {
  Red = 1,
  Yellow = 2,
  Green = 3,
}
